import {Component, Input, SimpleChanges} from '@angular/core';
import {ItemPlano} from "../../../modules/cadastro/models/lista-plano";
import {PlanoService} from "../../../modules/cadastro/services/plano.service";
import {Token} from "../../../modules/auth/models/token";
import {AuthService} from "../../../modules/auth/services/auth-service";
import {EmpresaService} from "../../../modules/cadastro/services/empresa.service";
import {AssinarRequest} from "../../models/assinar-request";

@Component({
  selector: 'app-assinatura',
  templateUrl: './assinatura.component.html',
  styleUrl: './assinatura.component.css',
  standalone: false
})
export class AssinaturaComponent {
  @Input() show = false;
  planos: ItemPlano[] = [];
  token = this.tokenService.AccessToken ?? new Token();

  constructor(private planoService: PlanoService,
              private tokenService: AuthService,
              private empresaService: EmpresaService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['show']) {
      this.carregarPlanos();
    }
  }

  private carregarPlanos() {
    this.planoService.selecionarPorIdTipoSaas(this.token.tipoSaas).subscribe(retorno => {
      if (retorno.sucesso)
        this.planos = retorno.dados.itens;
    });
  }

  assinarPlano(planoId: number){
    let empresaId = this.token.origem;
    let email = this.token.email;

    let requestAssinatura = new AssinarRequest();
    requestAssinatura.email = email;
    requestAssinatura.plano = planoId;
    requestAssinatura.empresa = empresaId;
    this.empresaService.assinarPlano(requestAssinatura).subscribe(retorno => {
      if (retorno.sucesso)
        this.redirecionarCheckout(retorno.dados);
    });
  }

  public redirecionarCheckout(url: string){
    window.location.href = url;
  }
}
